<template>
  <ItemPage
    title="Materiais"
    size="md"
  >
    <template
      v-if="subjectTextBooksView"
    >
      <MaterialFilters
        @setParameters="parameters = $event"
      />
      <div class="d-flex justify-end">
        <v-btn
          text
          class="mr-5"
          color="red"
          :disabled="loading || selectedItems.length === 0"
          @click="confirmBulkDelete"
        >
          apagar materiais <v-icon>mdi-delete</v-icon>
        </v-btn>
        <v-btn
          color="primary"
          text
          :disabled="loading"
          @click="newMaterial()"
        >
          <v-icon left>
            mdi-plus
          </v-icon> Adicionar novo material
        </v-btn>
      </div>
      <v-simple-table
        fixed-header
      >
        <template v-if="loading">
          <Load :loadingmsg="loadingMsg" />
        </template>
        <div
          v-else
          class="mb-5"
        >
          <v-data-table
            v-model="selectedItems"
            show-select
            :headers="headers"
            :items="contents"
            hide-default-footer
            :items-per-page="15"
            item-key="id"
            disable-sort
            @click:row="editMaterial($event)"
          >
            <!-- eslint-disable-next-line -->
            <template v-slot:item.name="{ item }">
              {{ item.name }} - {{ item.is_teacher_material ? 'professor' : 'aluno' }}
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.status="{ item }">
              {{ statusName(item.status) }}
            </template>
            <!-- eslint-disable-next-line -->
            <template v-slot:item.sistema="{ item }">
              {{ getNameEducationSystem(item.education_system_id) }} <br>
            </template>
          </v-data-table>
        </div>
      </v-simple-table>
      <v-pagination
        v-model="page"
        :length="totalPages"
        :total-visible="5"
        class="mt-4"
      />
    </template>
    <template v-else>
      Usuário sem permissão
    </template>
  </ItemPage>
</template>

<script>
import Load from '@/components/Loading.vue'
import utils from '@/api/utils.js'
import ItemPage from '@/components/pages/ItemPage.vue'
import { getTextForDisplay as statusName } from '@/enums/materialStatus'
import MaterialFilters from '@/components/contents/MaterialFilters.vue'

export default {
  components: {
    Load,
    MaterialFilters,
    ItemPage
  },
  data () {
    return {
      loading: false,
      loadingMsg: '',
      request: false,
      dialogMaterial: false,
      renderComponent: 0,
      selectedItems: [],
      contents: [],
      search: '',
      parameters: '',
      gradelevelGroups: [],
      systems: [],
      hierarchy: [],
      headers: [
        {
          text: 'ID',
          align: 'start',
          value: 'id'
        },
        {
          text: 'Nome',
          align: 'start',
          value: 'name'
        },
        {
          text: 'Ano',
          align: 'start',
          value: 'publishing_year'
        },
        {
          text: 'Sistema de ensino',
          align: 'center',
          value: 'sistema'
        },
        {
          text: 'Status',
          align: 'center',
          value: 'status'
        }
      ],

      // Pagination
      page: 1,
      totalPages: 1
    }
  },

  computed: {
    actions () {
      return [
        {
          label: 'Adicionar material',
          action: this.newMaterial,
          icon: 'mdi-home-city',
          disabled: !this.subjectTextBooksCreate
        }
      ]
    },
    subjectTextBooksView () {
      return utils.checkPermissions('subject-textbooks.view-any')
    },
    subjectTextBooksCreate () {
      return utils.checkPermissions('subject-textbooks.create')
    }
  },
  watch: {
    // selectedItems (newValue) {
    //   console.log(this.selectedItems)
    // },
    page (value) {
      this.listTextBooks(value)
    },
    parameters () {
      this.page = 1
      this.listTextBooks(this.page)
    }
  },
  async created () {
    if (this.subjectTextBooksView) {
      await Promise.all([
        this.listEducationSystems(),
        this.listTextBooks(this.page)
      ])
    }
  },
  methods: {

    confirmBulkDelete () {
      this.$dialog.confirm('Exclusão em massa')
        .text('Tem certeza que deseja apagar esses itens ?')
        .label('Apagar')
        .onConfirm(async () => {
          await this.bulkDelete()
        })
        .show()
    },
    async bulkDelete () {
      this.loading = true
      this.loadingMsg = 'Apagando materiais...'
      const ids = this.selectedItems.map((item) => item.id)
      const data = {
        ids
      }
      try {
        await this.$api.bulkDeleteTextBook(data)
        this.$store.dispatch('setSnackBar', { text: 'Materiais apagados com sucesso.', color: 'green' })
        this.selectedItems = []
        this.listTextBooks(this.page)
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Ocorreu um erro ao apagar materiais.', color: 'red' })
      } finally {
        this.loading = false
      }
    },
    async listTextBooks (page) {
      this.loading = true
      let content = []
      try {
        if (this.parameters.length === 0) {
          content = await this.$api.listTextBooks(page)
        } else {
          content = await this.$api.listTextBooks(page, this.parameters)
        }
        this.contents = content.data
        this.totalPages = content.meta.last_page
      } catch {
        this.$store.dispatch('setSnackBar', { text: 'Ocorreu um erro ao listar materiais.', color: 'red' })
      } finally {
        this.loading = false
      }
    },

    async listEducationSystems () {
      try {
        const response = await this.$api.listEducationSystems()
        this.systems = response
      } catch (e) {
        this.$store.dispatch('setSnackBar', { text: 'Ocorreu um erro ao obter sistemas de ensino.', color: 'red' })
      }
    },
    getNameEducationSystem (id) {
      return this.systems.find((item) => item.id === id).short_name
    },
    editMaterial (event) {
      this.$router.push({ name: 'conteudos.materiais.editar.id', params: { id: event.id } })
    },
    newMaterial () {
      this.$router.push({ name: 'conteudos.materiais.novo' })
    },
    statusName
  }
}
</script>
